module.exports = __webpack_public_path__ + "img/green_light.00b9e8bd.png";